module.exports = __webpack_public_path__ + "media/images/report_areas/wsc-seal-27dea7b8cfcf56b5be4f81e6f227d36d.png";